import React from "react";
import { Seven  } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
    return <ShreeDayTable staticData={Seven} chartData={chartData} />;
};

export default ShreeDay;
